<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="backButtonEnable"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="AttributeName" v-if="AttributeName" />
    </template>

    <div class="split-view-template css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <GcDataGrid
              :grouping="true"
              :export="true"
              :summary="true"
              :dataSourceConfig="getDataSourceConfig"
              :columns="getColumns"
              :gridToolbar="getToolbar"
              :padColumn="true"
              :id="'split-view-grid'"
              :rowClick="rowClickCallBack"
              v-if="dataLoaded"
              :heightPadding="20"
              :paging="false"
              ref="split-view-grid"
            />
          </div>
        </template>

        <template #rightContent>
          <gc-form-header-toolbar
            :toolbar-options="getFormConfig.headerToolbar"
            :data-model="formModel"
            :backRoute="pageRoute"
            :formLocation="getFormConfig.headerToolbar.toolbarFormLocation"
            v-if="renderForm"
            :itemSaveCallBack="itemSaveCallBack"
            :baseView="baseView"
          ></gc-form-header-toolbar>

          <div class="view-card responsive-paddings split-view-form">
            <GcForm
              :formOptions="formOptions"
              :formItems="getFormItems"
              :isNormal="true"
              :data-model="formModel"
              v-if="renderForm"
              :formMode="baseView.mode"
              :valueChangeCallBack="valueChangeCallBack"
              :checkValid="isValid"
              :validationGroup="'split-view-form'"
              :formLocation="'normal'"
              :formContentReady="formContentReady"
              :formHeight="getFormHeight"
              ref="split-view-form"
              :onFormKeypress="onFormKeypress"
            />
          </div>
        </template>
      </gc-split-view>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../../_services/storage";
import { ProductAttributeService } from "../../../_services/api/settings/products/product-attribute.service";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default {
  mixins: [RouteMixin, FormMixin],
  data() {
    return {
      backButtonEnable: true,
      AttributeName: undefined,
      dataLoaded: false,
      formOptions: {
        gcLabelLocation: "left",
      },
      formModel: {
        ColumnValue: undefined,
      },
      renderForm: false,
      isValid: false,
      formHeight: "auto",
      pageRoute: undefined,
      AttributeTableDefinitionRecordId: undefined,
      AttributeColumnDefinitionRecordId: undefined,
    };
  },
  async created() {
    this.$store.dispatch("ui/headerFormHeight", undefined);
    this.pageRoute = "/" + this.baseView.view;
    let view = this.baseView.view.split("-");
    this.AttributeName = capitalizeFirstLetter(view[2]);
    await this.getAttributeTableDefinition();
    this.getAttributeColumnDefinition();

    if (this.baseView.mode === "create") {
      this.renderForm = true;
    } else {
      if (this.baseView.id) await this.getRecord();
    }

    this.dataLoaded = true;
  },
  computed: {
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    getDataSourceConfig() {
      return {
        endpoint: "LocationSettings/" + this.AttributeName,
        filter: "",
        // select: ["Code", "Description", "Inactive", "IsDefault"],
        // select: [
        //   "Code",
        //   "Description",
        //   "Wastage",
        //   "SalesGLChartCode",
        //   "CostGLChartCode",
        //   "StockGLChartCode",
        //   "PurchaseGLChartCode",
        //   "Inactive",
        //   "SalesGLChartDescription",
        //   "CostGLChartDescription",
        //   "StockGLChartDescription",
        //   "PurchaseGLChartDescription",
        //   "IsDefault",
        // ],
        serverPaging: false,
        allowGrouping: false,
      };
    },
    getColumns() {
      return [
        {
          screenField: "ColumnValue",
          dataField: "ColumnValue",
          label: this.AttributeName,
          filterIndex: 1,
          filterDataField: "ColumnValue",
          filterLabel: this.AttributeName,
          dataType: "string",
          type: "Text",
          editorOptions: {
            valueChangeEvent: "input",
          },
          filterValueChangeEvent: "input",
        },
      ];
    },
    getToolbar() {
      return {
        search: true,
        columnChooser: false,
        export: false,
        openFilter: true,
        expand: false,
        customButtons: [
          {
            icon: "plus",
            label: "Add New",
            route: `/${this.baseView.view}/create`,
            clickAction: {},
            buttonLocation: "left",
            visible: FeatureStorage.checkPermission(
              this.$route.meta.applicationFeatureCode,
              "create"
            ),
          },
        ],
      };
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "ColumnValue",
              required: true,
              label: {
                text: this.AttributeName,
              },
              editorOptions: {
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
            },
          ],
        },
      ];
    },
    getFormHeight() {
      return 60;
    },
    getFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: FeatureStorage.checkPermission(
            this.$route.meta.applicationFeatureCode,
            "create"
          ),
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormLocation: "after",
        },
      };

      return form;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  methods: {
    onFormKeypress(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
      }
    },
    /**
     * Fetches a record based on the current baseView id and sets the form model.
     */
    async getRecord() {
      await ProductAttributeService.getByCode(this.baseView.id).then((res) => {
        let data = res.data.value[0];
        this.formModel = data;
        this.renderForm = true;
      });
    },
    /**
     * Retrieves the attribute table definition for a given table name.
     * @param {string} tableName - The name of the table for which the attribute table definition is to be retrieved.
     * @returns {Object} The attribute table definition object containing metadata and schema information for the specified table.
     */
    async getAttributeTableDefinition() {
      await ProductAttributeService.getAttributeTableDefinition().then(
        (res) => {
          if (res.data.value.length > 0) {
            this.AttributeTableDefinitionRecordId = res.data.value[0].RecordId;
          }
        }
      );
    },
    /**
     * Retrieves the column definition for a given attribute.
     * @param {string} attributeName - The name of the attribute for which the column definition is to be retrieved.
     * @returns {Object|null} - The column definition object if found, otherwise null.
     */
    async getAttributeColumnDefinition() {
      await ProductAttributeService.getAttributeColumnDefinition(
        `AttributeTableDefinitionRecordId eq ${this.AttributeTableDefinitionRecordId} and AttributeName eq '${this.AttributeName}' and DataSourceType eq 'Value Lookup'`
      ).then((res) => {
        if (res.data.value.length > 0) {
          this.AttributeColumnDefinitionRecordId = res.data.value[0].RecordId;
        }
      });
    },
    /**
     * Handles the change of local routes within the application.
     *
     * This function is triggered when there is a change in the local route.
     * It performs necessary actions to update the application state or UI
     * based on the new route.
     */
    async handleLocalRouteChange() {
      this.renderForm = false;
      if (this.baseView.mode === "create") {
        this.formModel.ColumnValue = undefined;
        this.renderForm = true;
      } else {
        if (this.baseView.id) await this.getRecord();
        this.renderForm = true;
      }
    },
    /**
     * Handles the functionality for the back button.
     * This function is typically used to navigate to the previous page or state.
     */
    backButtonFunction() {
      this.$router.push({
        path: "/settings/products",
      });
    },
    /**
     * Callback function to handle row click events in a table.
     * @returns {void}
     */
    rowClickCallBack(e) {
      if (!e.data) return;
      this.onRowClicked(e, {
        view: this,
        page: this.baseView.view,
        mode: "review",
        idProperty: "RecordId",
        idMode: "Guid",
      });
    },
    /**
     * Callback function to handle value changes.
     *
     * @callback valueChangeCallBack
     * @param {string} isValid - validations status of the form elements.
     * @param {string} brokenRules - brokenRules, after validation is done.
     */
    async valueChangeCallBack(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.showLoading(true);
        let payload = {
          ColumnValue: this.formModel.ColumnValue,
          AttributeColumnDefinitionRecordId:
            this.AttributeColumnDefinitionRecordId,
        };

        if (this.baseView.mode !== "create")
          delete payload.AttributeColumnDefinitionRecordId;

        await ProductAttributeService.save(
          this.baseView.mode,
          payload,
          this.baseView.id
        )
          .then((res) => {
            this.showLoading(false);
            this.setIgnoreRouteChangeConfirmation();
            let recordID =
              this.baseView.mode === "create"
                ? res.data.RecordId
                : this.baseView.id;
            this.$router.push({
              path: this.pageRoute + "/review/" + recordID,
            });
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });
      }

      this.isValid = false;
    },
    /**
     * This function is called when the form content is ready.
     * It performs necessary actions to initialize or handle the form content.
     */
    formContentReady(e) {
      if (this.baseView.mode === "create" || this.baseView.mode === "edit")
        this.$nextTick(() => {
          if (e) e.component.getEditor("ColumnValue").focus();
        });
    },
    /**
     * function to handle the save operation for an item.
     * This function is triggered when an item needs to be saved.
     */
    itemSaveCallBack() {
      this.isValid = true;
    },
  },
};
</script>
